import DarkModeOutlinedIcon from "@mui/icons-material/DarkModeOutlined";
import LightModeOutlinedIcon from "@mui/icons-material/LightModeOutlined";
import { Card, CardContent, Grid, Typography, useTheme, Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from "@mui/material";
import Paper from "@mui/material/Paper";
import { styled } from "@mui/material/styles";
import Tooltip from "@mui/material/Tooltip";
import { useEffect, useState } from "react";
import Pin from "../../assets/img/pin.png";
import Target from "../../assets/img/svg/target.svg";
import BarChartProductionTracking from "../../components/chart/BarChartProductionTracking";
import HeaderCustom from "../../components/header/HeaderCustom";
import { tokens } from "../../theme";
import axios from 'axios'
import { apiUrl } from '../../constants'
import { useParams } from 'react-router-dom';
import db, { firebase } from "../../firebase-config"
import moment from 'moment-timezone';
import { useSelector } from 'react-redux';

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: "#8ad4c1",
  padding: theme.spacing(0),
  width: "100%",
}));
const ItemSecond = styled(Paper)(({ theme }) => ({
  backgroundColor: "#e1efec",
  padding: theme.spacing(0),
  width: "100%",
}));
const GridDashed = styled(Grid)(({ colors }) => ({
  "&:not(:last-child)": {
    borderRight: `2px solid ${colors.secondary[500]}`,
  },
  height: "100%",
  justifyContent: "center",
  display: "flex",
  flexDirection: "column",
}));
const CardItem = styled(Card)(({ colors }) => ({
  background: colors.neutral["green"],
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
}));
const TypographyCardHeader = styled(Typography)(({ colors }) => ({
  color: colors.neutral["black"],
  fontWeight: "bold",
  fontSize: 46,
  lineHeight: "9vh",
}));
const BarCardHeader = styled("div")(({ colors }) => ({
  width: "60%",
  borderRadius: "4px",
  background: "#8ad4c1",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  padding: "3px 10px",
  marginTop: "5px",
}));
const ChipStyled = styled("Div")(({ colors }) => ({
  background: "#8ad4c1",
  padding: "2px 10px",
  color: colors.neutral["black"],
  fontWeight: "bold",
  fontSize: 46,
  "& :last-child": {
    fontSize: "16px",
    fontWeight: "normal",
    marginBottom: "-5px",
  },
  "& :first-child": { marginBottom: "-5px" },
  lineHeight: "22px",
  minHeight: "32px",
  borderRadius: "4px",
  display: "flex",
  alignItems: "center",
  flexDirection: "column",
  justifyContent: "center",
}));
const CardContentStyled = styled(Grid)(({ }) => ({
  fontSize: "40px",
  "& :last-child": {
    fontWeight: "bold",
  },
}));

const ProductionChickenP1 = () => {
  const display = useSelector(state => state.auth.email);
  const { bu, plant, factory, line } = useParams();
  const today = new Date();
  const yesterday = new Date(today);
  yesterday.setDate(today.getDate() - 2);
  yesterday.setHours(0, 0, 0, 0);
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const [chickenYard, setChickenYard] = useState([]);
  const [chickenYardHistory, setChickenYardHistory] = useState([]);
  const [noData, setNoData] = useState(false);

  const [shift, setShift] = useState({});
  const [queueItems, setQueueItems] = useState([]);
  const [accumulatedDead, setAccumulatedDead] = useState(0);

  const [open, setOpen] = useState();
  const [addChickenYard, setAddChickenYard] = useState(null);
  const [tagList, setTagList] = useState([]);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleAddChickenYard = (event) => {
    if (event.target.name === "dead_chicken") {
      setAddChickenYard(event.target.value);
    }
  };

  const handleSubmitAddDeadChicken = async () => {
    try {
      const collectionName = "prod_mes_ignition_slaughter_airchill_tag_list";
      const documentName = ` thailand4070ck_koratlivechicken${line}TotalDeadChickens`;

      const docRef = db.collection(collectionName).doc(documentName);

      if (!addChickenYard || isNaN(addChickenYard)) {
        alert("กรุณากรอกจำนวนไก่ตายเป็นตัวเลขที่ถูกต้อง!");
        return;
      }
      const data = {
        TOTALDEADCHICKEN: Number(addChickenYard),
        USER: display,
        TIMESTAMP: firebase.firestore.FieldValue.serverTimestamp(),
      };

      await docRef.set(data);

      setAddChickenYard(null);
      setOpen(false);
    } catch (error) {
      console.error("Error updating target:", error);
      alert("เกิดข้อผิดพลาดในการอัปเดตจำนวนไก่ตาย");
    }
  };

  const get_api = () => {
    try {
      const buName = bu;
      const plantName = plant;
      const factoryName = factory;
      const lineName = line;

      const apiMapping = {
        "แปรรูปไก่_4070_SLHKorat_Line1": apiUrl.CHECKEN_YARD_LINE1,
        "แปรรูปไก่_4070_SLHKorat_Line2": apiUrl.CHECKEN_YARD_LINE2,
      };

      const key = `${buName}_${plantName}_${factoryName}_${lineName}`;

      return apiMapping[key];
    } catch (error) {
      console.error("Error in chicken yard:", error);
      return null;
    }
  };

  useEffect(() => {
    const subscriberTagList = db
      .collection("prod_mes_ignition_slaughter_airchill_tag_list")
      .onSnapshot((querySnapshot) => {
        const tagListData = querySnapshot.docs.map(doc => ({
          ...doc.data(),
          id: doc.id,
        }));
        setTagList(tagListData);
      });
    return () => {
      subscriberTagList();
    }
  }, []);


  useEffect(() => {
    async function fetchMyAPI() {
      try {
        const response = await axios.get(`${get_api()}`, {
          headers: {
            authorizationToken: "lFao}A!iCSg3v'sT{=*p*irT2f@#.X(9.1B:M9R'z*Qy=y\\F--Jme7EAQ){-A2x)",
          },
        });

        if (response.status === 200) {
          setChickenYard(response.data);
          sessionStorage.setItem("chickenYard", JSON.stringify(response.data));
          setNoData(1);
        }
      } catch (error) {
        setNoData(2);
        console.log("error:", error);
      }
    }

    fetchMyAPI();

    const interval = setInterval(fetchMyAPI, 1 * 60 * 1000);

    return () => clearInterval(interval);
  }, []);


  useEffect(() => {
    const storedCheckenYard = sessionStorage.getItem("chickenYard");
    if (storedCheckenYard) setChickenYardHistory(JSON.parse(storedCheckenYard));
  }, []);

  const findTAG = (key) => (tagList || []).find((a) => (a?.TAG || "").includes(key)) || null;
  const findID = (key) => (tagList || []).find((a) => (a?.id || "").includes(key)) || null;

  const speedShackel = findTAG(`SLH_Korat.4070.00000000000000.Thailand.Chicken_Counter.HangingArea.${line}.SpeedShackel`);
  const chickenPerTruck = findTAG(`SLH_Korat.4070.00000000000000.Thailand.Chicken_Counter.HangingArea.${line}.ChickenPerTruck`);
  const truckStartTime = findTAG(`SLH_Korat.4070.00000000000000.Thailand.Chicken_Counter.HangingArea.${line}.TruckStartTime`);
  const chickenPerShift = findTAG(`SLH_Korat.4070.00000000000000.Thailand.Chicken_Counter.HangingArea.${line}.ChickenPerShift`);
  const deadChicken = findID(`thailand4070ck_koratlivechicken${line}TotalDeadChickens`);

  const t = chickenYard?.current_loading_queue?.target
  const q = chickenYard?.current_loading_queue?.quantity;
  const v = chickenPerTruck?.VALUE;
  const truckStart = moment(truckStartTime?.VALUE, "HH:mm").format("HH:mm");
  const perShiftRaw = chickenPerShift?.VALUE;
  const perShift = perShiftRaw == null || perShiftRaw === 0 ? "NA" : Number(perShiftRaw);

  const persentActual = !q || q === 'NA' || !v ? 0 : Math.round((v / q) * 100);
  const persentActualTotal = !t || t === 'NA' || !chickenPerShift?.VALUE ? 0 : Math.round((chickenPerShift?.VALUE / t) * 100);
  const qs = chickenYard?.current_loading_queue;

  let idealChicken = "NA";
  let accumulatedMinutes = 0;

  function parseShiftStartToDate(str) {
    if (!str || typeof str !== 'string') return null;

    const tryDate = new Date(str);
    if (!isNaN(tryDate.getTime())) return tryDate;

    const parts = str.split(' ');
    const datePart = parts[0];
    const timePart = parts[1] ?? '00:00:00';

    const [mm, dd, yyyy] = datePart.split('/').map(Number);
    if (!mm || !dd || !yyyy) return null;

    const [HH = 0, Min = 0, Sec = 0] = timePart.split(':').map(Number);

    const d = new Date(yyyy, mm - 1, dd, HH, Min, Sec);
    return isNaN(d.getTime()) ? null : d;
  }

  const invalidForecastTime =
    !qs?.shiftStart ||
    !qs?.lineSpeed ||
    !qs?.target ||
    qs.shiftStart === "NA" ||
    qs.lineSpeed === "NA" ||
    qs.target === "NA";

  const forecastTime = invalidForecastTime
    ? "NA"
    : (() => {
      const shiftStart = parseShiftStartToDate(String(qs.shiftStart));
      if (!shiftStart) return "NA";

      const target = Number(qs.target);
      const lineSpeed = Number(qs.lineSpeed);

      if (!Number.isFinite(target) || !Number.isFinite(lineSpeed) || lineSpeed <= 0) {
        return "NA";
      }

      const minutesToAdd = Math.round(target / lineSpeed);

      const forecast = new Date(shiftStart.getTime() + minutesToAdd * 60000);

      const hh = String(forecast.getHours()).padStart(2, "0");   // ข้ามวันจะเป็น 00, 01, 02...
      const mm = String(forecast.getMinutes()).padStart(2, "0");

      return `${hh}:${mm}`;
    })();


  const invalidForecastCompletedTime =
    !qs?.lineSpeed ||
    !qs?.quantity ||
    qs.lineSpeed === "NA" ||
    qs.target === "NA" ||
    truckStartTime?.VALUE === undefined;

  const forecastCompletedTime = invalidForecastCompletedTime
    ? "NA"
    : (() => {
      const [h, m] = truckStart.split(":");
      const startMinutes = Number(h) * 60 + Number(m);
      const quantity = Number(qs.quantity);
      const lineSpeed = Number(qs.lineSpeed);

      if (!quantity || !lineSpeed) return "NA";

      const minutesToAdd = Math.round(quantity / lineSpeed);
      const totalMinutes = startMinutes + minutesToAdd;
      const finalMinutes = totalMinutes % 1440;

      const hh = String(Math.floor(finalMinutes / 60)).padStart(2, "0");
      const mm = String(finalMinutes % 60).padStart(2, "0");

      return `${hh}:${mm}`;
    })();

  const invalid =
    !qs?.shiftNo ||
    !qs?.shiftStart ||
    !qs?.lineSpeed ||
    !qs?.target ||
    qs.shiftNo === "NA" ||
    qs.shiftStart === "NA" ||
    qs.lineSpeed === "NA" ||
    qs.target === "NA";

  if (!invalid) {
    const shiftNo = Number(qs.shiftNo);
    const lineSpeed = Number(qs.lineSpeed);
    const target = Number(qs.target);

    const shiftStart = new Date(qs.shiftStart);
    const now = new Date();

    let endShift;

    if (shiftNo === 1) {
      endShift = new Date(shiftStart);
      endShift.setHours(15, 30, 0, 0);
    } else if (shiftNo === 2) {
      endShift = new Date(shiftStart);
      endShift.setDate(endShift.getDate() + 1);
      endShift.setHours(3, 30, 0, 0);
    }

    const effectiveEnd = now > endShift ? endShift : now;

    const accumulatedMinutes = Math.max(
      0,
      Math.floor((effectiveEnd - shiftStart) / 60000)
    );

    let ideal = lineSpeed * accumulatedMinutes;

    if (ideal > target) ideal = target;

    idealChicken = ideal;
  }

  let persentUtilization = "NA";
  if (idealChicken !== "NA" && idealChicken > 0 && perShift !== "NA") {
    persentUtilization = Math.round((perShift / idealChicken) * 100);
  }


  useEffect(() => {
    setAccumulatedDead('NA');
    setQueueItems([
      {
        queueNumber: 13,
        lot: 156,
        sublot: 111,
        licensePlate: "กข1234",
        quantity: 3050,
        farm: "กิจเจริญ3-เล้า7",
        weight: "2.5 kg",
        queueTime: "9:45",
        actualTime: "10:00",
        status: "loading",
      },
    ]);
  }, []);

  useEffect(() => {
    function updateShift() {
      const now = new Date();
      const hour = now.getHours();

      if (hour >= 6 && hour < 16) {
        // 06:00 - 17:59 → กลางวัน
        setShift({ SHIFT: "D" });
      } else {
        // 18:00 - 05:59 → กลางคืน
        setShift({ SHIFT: "N" });
      }
    }

    updateShift(); // เรียกครั้งแรกตอน mount

    const timer = setInterval(updateShift, 60 * 1000); // อัพเดททุก 1 นาที
    return () => clearInterval(timer); // clear ตอน unmount
  }, []);

  function getColorByTime(timeStr) {
    // แปลง "HH:mm" เป็นนาที
    const [h, m] = timeStr.split(":").map(Number);
    const totalMinutes = h * 60 + m;

    const morningCut = 16 * 60; // 16:00 → 960 นาที
    const nightCut = 3 * 60; // 03:00 → 180 นาที

    // เงื่อนไข: > 16:00 หรือ > 03:00 แต่ยังเป็นช่วงกลางคืน (0-5 โมงเช้า)
    if (
      totalMinutes > morningCut ||
      (totalMinutes > nightCut && totalMinutes < 12 * 60)
    ) {
      return "red";
    }
    return colors.neutral.black;
  }

  const renderQueueItem = (item) => {
    return (
      <>
        <Grid item xs={12}>
          <CardItem colors={colors}>
            <BarCardHeader colors={colors}>
              <ChipStyled colors={colors}>
                Loading
              </ChipStyled>
              <TypographyCardHeader colors={colors}>
                คิวที่ {noData === 1 ? (chickenYard?.current_queue_live_bird?.IsComplete === true ? (chickenYard?.current_queue_live_bird?.Data?.QUEUE_NO === undefined ? (chickenYardHistory?.current_queue_live_bird?.Data?.QUEUE_NO === undefined ? '-' : chickenYardHistory?.current_queue_live_bird?.Data?.QUEUE_NO === null ? 'NA' : chickenYardHistory?.current_queue_live_bird?.Data?.QUEUE_NO) : chickenYard?.current_queue_live_bird?.Data?.QUEUE_NO === null ? 'NA' : chickenYard?.current_queue_live_bird?.Data?.QUEUE_NO) : '-') : '-'}
              </TypographyCardHeader>
              <ChipStyled colors={colors}>
                <Grid item xs={12}>
                  {noData === 1 ? (chickenYard?.current_queue_live_bird?.IsComplete === true ? (chickenYard?.current_queue_live_bird?.Data?.LOT_NO === undefined ? (chickenYardHistory?.current_queue_live_bird?.Data?.LOT_NO === undefined ? '-' : chickenYardHistory?.current_queue_live_bird?.Data?.LOT_NO === null ? 'NA' : chickenYardHistory?.current_queue_live_bird?.Data?.LOT_NO) : chickenYard?.current_queue_live_bird?.Data?.LOT_NO === null ? 'NA' : chickenYard?.current_queue_live_bird?.Data?.LOT_NO) : '-') : '-'}
                  -
                  {noData === 1 ? (chickenYard?.current_queue_live_bird?.IsComplete === true ? (chickenYard?.current_queue_live_bird?.Data?.SUBLOT === undefined ? (chickenYardHistory?.current_queue_live_bird?.Data?.SUBLOT === undefined ? '-' : chickenYardHistory?.current_queue_live_bird?.Data?.SUBLOT === null ? 'NA' : chickenYardHistory?.current_queue_live_bird?.Data?.SUBLOT) : chickenYard?.current_queue_live_bird?.Data?.SUBLOT === null ? 'NA' : chickenYard?.current_queue_live_bird?.Data?.SUBLOT) : '-') : '-'}
                </Grid>
                <Grid item xs={12} style={{ fontSize: 24, paddingTop: 10 }}>
                  lot - Sublot
                </Grid>
              </ChipStyled>
            </BarCardHeader>
            <CardContent sx={{ padding: "10px 10px", display: "contents" }}>
              <Grid container item xs={12} p={1} spacing={1}>
                <CardContentStyled container item xs={6}>
                  <Item>
                    <Grid
                      container
                      rowSpacing={0}
                      columnSpacing={{ xs: 0, sm: 0, md: 0 }}
                      p={0.5}
                      style={{ height: "100%" }}
                      alignItems={"center"}
                    >
                      <GridDashed colors={colors} item xs={6}>
                        <Typography
                          style={{
                            color: colors.neutral["black"],
                            fontWeight: "bold",
                            fontSize: 40,
                            lineHeight: "60px",
                            textAlign: "center",
                          }}
                        >
                          ความเร็วราว
                        </Typography>
                        <ChipStyled colors={colors} sx={{ lineHeight: "40px" }}>
                          <Grid item xs={12}>
                            Standard
                            <span
                              style={{
                                marginLeft: "20px",
                                fontSize: "40px",
                                fontWeight: "bold",
                              }}
                            >
                              {noData === 1 ? (chickenYard?.current_loading_queue?.lineSpeed ?? chickenYardHistory?.current_loading_queue?.lineSpeed ?? '-') : '-'}
                            </span>
                          </Grid>
                          <Grid item xs={12} sx={{ marginLeft: "85px" }} style={{ fontSize: 24 }}>
                            (ตัว/นาที)
                          </Grid>
                        </ChipStyled>
                      </GridDashed>
                      <GridDashed colors={colors} item xs={6}>
                        <Typography
                          style={{
                            color: colors.neutral["black"],
                            fontWeight: "bold",
                            fontSize: 40,
                            lineHeight: "60px",
                            textAlign: "center",
                          }}
                        >
                          ประสิทธิภาพแขวน
                        </Typography>
                        <ChipStyled colors={colors} sx={{ lineHeight: "40px" }} style={{ fontSize: 24 }}>
                          <Grid item xs={12} style={{ fontSize: 46 }}>
                            Actual
                            <span
                              style={{
                                marginLeft: "20px",
                                fontSize: "40px",
                                fontWeight: "bold",
                                color:
                                  speedShackel?.VALUE < (noData === 1 ? (chickenYard?.current_loading_queue?.lineSpeed ?? chickenYardHistory?.current_loading_queue?.lineSpeed ?? 0) : 0)
                                    ? "red"
                                    : colors.neutral.black,
                              }}
                            >
                              {speedShackel?.VALUE === undefined ? 'NA' : speedShackel?.VALUE}
                            </span>
                          </Grid>
                          <Grid item xs={12} sx={{ marginLeft: "85px" }} style={{ fontSize: 24 }}>
                            (ตัว/นาที)
                          </Grid>
                        </ChipStyled>
                      </GridDashed>
                    </Grid>
                  </Item>
                </CardContentStyled>
                <CardContentStyled container item xs={6}>
                  <Item>
                    <Grid
                      container
                      rowSpacing={0}
                      columnSpacing={{ xs: 0, sm: 0, md: 0 }}
                      p={0.5}
                      alignItems={"center"}
                    >
                      <Grid item xs={8} md={8}>
                        <Grid
                          display={"flex"}
                          justifyContent={"space-around"}
                          item
                          xs={12}
                        >
                          <Typography
                            style={{
                              color: colors.neutral["black"],
                              fontWeight: "bold",
                              fontSize: 40,
                              lineHeight: "40px",
                              textAlign: "center",
                              padding: "6px 0",
                            }}
                          >
                            จำนวนไก่แขวน
                          </Typography>
                          <Typography
                            style={{
                              color: colors.neutral["black"],
                              fontWeight: "normal",
                              fontSize: 40,
                              lineHeight: "40px",
                              textAlign: "center",
                              padding: "6px 0",
                              display: "flex",
                            }}
                          >
                            <img
                              src={Target}
                              width={32}
                              height={32}
                              alt="Target"
                            />
                            <span style={{ fontWeight: "bold", padding: "0 3px" }}>
                              {
                                noData === 1
                                  ? (
                                    chickenYard?.current_loading_queue?.quantity != null
                                      ? chickenYard?.current_loading_queue?.quantity?.toLocaleString()
                                      : chickenYardHistory?.current_loading_queue?.quantity != null
                                        ? chickenYardHistory?.current_loading_queue?.quantity?.toLocaleString()
                                        : '-'
                                  )
                                  : '-'
                              }
                            </span>{" "}
                            ตัว
                          </Typography>
                        </Grid>
                        <BarChartProductionTracking
                          target_quantity={chickenYard?.current_loading_queue?.quantity}
                          actual_weight={chickenPerTruck?.VALUE === undefined ? 0 : chickenPerTruck?.VALUE}
                          target_now={-1}
                          persent={0}
                          chart_color={"#17966d"}
                          fontsize={20}
                          width_svg={18}
                          height_svg={18}
                          pin={Pin}
                          ml={0}
                          height="100px"
                          width="100%"
                        />
                        <Typography
                          style={{
                            color: colors.neutral["black"],
                            fontWeight: "bold",
                            fontSize: 40,
                            lineHeight: "40px",
                            textAlign: "center",
                            padding: "6px 0",
                            marginTop: "-79px",
                          }}
                        >
                          {chickenPerTruck?.VALUE === undefined ? 0 : Number(chickenPerTruck?.VALUE).toLocaleString()} (
                          {persentActual}
                          %)
                        </Typography>
                      </Grid>
                      <Grid colors={colors} item md={4} xs={4}>
                        <Typography
                          style={{
                            color: colors.neutral["black"],
                            fontWeight: "bold",
                            fontSize: 40,
                            lineHeight: "40px",
                            textAlign: "center",
                          }}
                        >
                          เริ่มแขวน
                          <br /> {truckStartTime?.VALUE === undefined ? 'NA' : moment(truckStartTime?.VALUE, "HH:mm").format("HH:mm")}
                          <br /> แล้วเสร็จ
                          <br /> {forecastCompletedTime}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Item>
                </CardContentStyled>
              </Grid>
            </CardContent>
          </CardItem>
        </Grid>
        <Grid container item xs={12} style={{ paddingTop: 8 }}>
          <ItemSecond>
            <Grid
              container
              rowSpacing={0}
              columnSpacing={{ xs: 0, sm: 0, md: 0 }}
              p={0.5}
              alignItems={"center"}
            >
              <Grid
                item
                xs={8}
                md={8}
                pr={1}
                sx={{ borderRight: `2px solid ${colors.secondary[500]}` }}
              >
                <Grid
                  display={"flex"}
                  justifyContent={"space-between"}
                  item
                  xs={12}
                  alignItems={"center"}
                >
                  <Tooltip title="add dead chicken" arrow>
                    <Typography
                      onClick={handleClickOpen}
                      style={{
                        color: colors.neutral["black"],
                        fontWeight: "bold",
                        fontSize: 40,
                        lineHeight: "50px",
                        textAlign: "center",
                        padding: "10px 0",
                      }}
                    >
                      จำนวนไก่เข้าสะสม ต่อกะ <br />
                      ตายสะสม{" "}
                      <span style={{ color: "red" }}>{deadChicken?.TOTALDEADCHICKEN}</span> ตัว
                    </Typography>
                  </Tooltip>
                  <Typography
                    style={{
                      color: colors.neutral["black"],
                      fontWeight: "bold",
                      fontSize: 40,
                      lineHeight: "40px",
                      textAlign: "center",
                      padding: "6px",
                      display: "flex",
                    }}
                  >
                    <img src={Target} width={36} height={36} alt="Target" />
                    Target {noData === 1 ? ((chickenYard?.current_loading_queue?.target)?.toLocaleString() ?? (chickenYardHistory?.current_loading_queue?.target)?.toLocaleString() ?? '-') : '-'} ตัว
                  </Typography>
                </Grid>
                <BarChartProductionTracking
                  target_quantity={noData === 1 ? (chickenYard?.current_loading_queue?.target ?? chickenYardHistory?.current_loading_queue?.target ?? 0) : 0}
                  actual_weight={chickenPerShift?.VALUE === undefined ? 0 : chickenPerShift?.VALUE}
                  target_now={idealChicken}
                  chart_color={"#287c6e"}
                  position={0}
                  fontsize={28}
                  width_svg={18}
                  height_svg={18}
                  pin={Pin}
                  ml={0}
                  height="110px"
                  width="98%"
                  markerSize={-1}
                  disableText={true}
                  y={27}
                  lineColor={"#000000"}
                />
                <Typography
                  style={{
                    color: colors.neutral["black"],
                    fontWeight: "bold",
                    fontSize: 40,
                    lineHeight: "40px",
                    textAlign: "center",
                    padding: "6px 0",
                    marginTop: "-75px",
                  }}
                >
                  {chickenPerShift?.VALUE === undefined ? 0 : Number(chickenPerShift?.VALUE).toLocaleString()} (
                  {persentActualTotal}
                  %)
                </Typography>
              </Grid>
              <Grid
                colors={colors}
                item
                xs={2}
                display={"flex"}
                flexDirection={"column"}
                justifyContent={"space-evenly"}
                sx={{
                  borderRight: `2px solid ${colors.secondary[500]}`,
                  height: 190,
                }}
              >
                <Typography
                  style={{
                    color: colors.neutral["black"],
                    fontWeight: "bold",
                    fontSize: 44,
                    lineHeight: "0px",
                    textAlign: "center",
                  }}
                >
                  Utilization
                </Typography>
                <Typography
                  style={{
                    color: colors.neutral["black"],
                    fontWeight: "bold",
                    fontSize: 80,
                    lineHeight: "20px",
                    textAlign: "center",
                  }}
                >
                  {persentUtilization}%
                </Typography>
              </Grid>
              <Grid
                colors={colors}
                item
                xs={2}
                display={"flex"}
                flexDirection={"column"}
                justifyContent={"space-evenly"}
                sx={{
                  height: 120,
                }}
              >
                <Typography
                  style={{
                    color: colors.neutral["black"],
                    fontWeight: "bold",
                    fontSize: 36,
                    lineHeight: "40px",
                    textAlign: "center",
                  }}
                >
                  คาดการณ์
                  <br />
                  แล้วเสร็จ
                </Typography>
                <Typography
                  style={{
                    color: colors.neutral["black"],
                    fontWeight: "bold",
                    fontSize: 56,
                    lineHeight: "60px",
                    textAlign: "center",
                    position: "relative",
                    bottom: 4,
                    color: getColorByTime(forecastTime),
                  }}
                >
                  {forecastTime}
                </Typography>
              </Grid>
            </Grid>
          </ItemSecond>
        </Grid>
      </>
    );
  };

  const mapQueueItems = () => {
    if (Array.isArray(queueItems) && queueItems.length > 0) {
      return queueItems.map((item, index) => renderQueueItem(item));
    } else {
      return (
        <Grid item xs={12}>
          <div style={{ color: "#fff", textAlign: "center" }}>
            No queue items available.
          </div>
        </Grid>
      );
    }
  };

  return (
    <>
      <Grid container justifyContent={"center"}>
        <Grid item xs={12}>
          <HeaderCustom
            icon={
              shift?.SHIFT === "N" ? (
                <Tooltip title="กะ Night" arrow>
                  <DarkModeOutlinedIcon style={{ color: "#ffffff" }} />
                </Tooltip>
              ) : (
                <Tooltip title="กะ Day" arrow>
                  <LightModeOutlinedIcon style={{ color: "#ffffff" }} />
                </Tooltip>
              )
            }
          >
            ลานไก่เป็น {line}
          </HeaderCustom>
        </Grid>
        <Grid item xs={12} style={{ padding: 8 }}>
          {mapQueueItems()}
        </Grid>
      </Grid>

      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth
      >
        <DialogTitle id="alert-dialog-title" >
          Add Dead Chicken number
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={1}>
            <Grid item md={6} xs={6}>
              <TextField
                type="number"
                fullWidth
                label="Dead Chicken"
                name="dead_chicken"
                required
                value={addChickenYard}
                variant="standard"
                sx={{
                  "& .MuiOutlinedInput-input": {
                    color: "#000000",
                    fontFamily: 'CPF_Imm_Sook',
                    fontSize: 18
                  },
                }}
                onChange={handleAddChickenYard}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => handleClose(false)}>Cancel</Button>
          <Button disabled={!addChickenYard} onClick={() => { handleClose(false); handleSubmitAddDeadChicken(); }} autoFocus>Save</Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ProductionChickenP1;
